import { render, staticRenderFns } from "./SpeechRecEditor.vue?vue&type=template&id=41510498&scoped=true&"
import script from "./SpeechRecEditor.vue?vue&type=script&lang=js&"
export * from "./SpeechRecEditor.vue?vue&type=script&lang=js&"
import style0 from "./SpeechRecEditor.vue?vue&type=style&index=0&id=41510498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41510498",
  null
  
)

export default component.exports